/* src/app/conciliadora-config/config-tipos/config-tipos.component.scss */
.tipos-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}
.tipo-edit-form {
  margin-bottom: 12px;
}
.tipo-edit-form nz-card {
  border-radius: 6px;
  border: 1px solid #d9d9d9;
  background: #fafafa;
}
.tipo-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
}
.dpara-section {
  margin-top: 12px;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 12px;
  background: #fff;
}
.dpara-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.dpara-header .dpara-title {
  font-weight: 600;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  gap: 6px;
}
.dpara-list-header {
  display: flex;
  gap: 8px;
  padding-bottom: 4px;
  margin-bottom: 4px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 12px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.45);
}
.dpara-row {
  display: flex;
  gap: 8px;
  margin-bottom: 4px;
  align-items: center;
}
.dpara-col-campo {
  flex: 1;
  min-width: 0;
}
.dpara-col-valor {
  flex: 1;
  min-width: 0;
}
.dpara-col-action {
  flex: 0 0 32px;
  text-align: center;
}
.dpara-empty {
  padding: 8px 0;
}
.dpara-empty ::ng-deep .ant-empty-description {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.35);
}
.param-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
}
.no-params {
  color: rgba(0, 0, 0, 0.25);
}
.newmode-tag {
  margin-left: 8px;
  font-size: 11px;
  line-height: 16px;
  padding: 0 6px;
  vertical-align: middle;
}
/*# sourceMappingURL=config-tipos.component.css.map */
